import React from 'react';

import {deprecatedTrackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {
  starAnalyticsDashboards,
  unstarAnalyticsDashboards,
} from 'insights/analytics-dashboards/AnalyticsDashboardActions';

import {AnalyticsDashboardSearchAttributesGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsDashboardSearchAttributesGraphQL';
import BaseAnalyticsSidepanelItem, {BaseAnalyticsSidepanelItemProps} from './BaseAnalyticsSidepanelItem';

export type AnalyticsDashboardSidepanelItemProps = {
  analyticsDashboard: AnalyticsDashboardSearchAttributesGraphQL;
} & Pick<
  BaseAnalyticsSidepanelItemProps<AnalyticsDashboardSearchAttributesGraphQL>,
  'active' | 'isCompact' | 'openResult' | 'isChild'
>;

export default function AnalyticsDashboardSidepanelItem(
  props: AnalyticsDashboardSidepanelItemProps
): JSX.Element {
  function handleClickStar(): void {
    if (props.analyticsDashboard.starred) {
      unstarAnalyticsDashboards([props.analyticsDashboard.id]);
    } else {
      starAnalyticsDashboards([props.analyticsDashboard.id]);
    }
  }

  const trackOpenEvent = (dashboard: AnalyticsDashboardSearchAttributesGraphQL): void => {
    deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.OPENED_DASHBOARD_FROM_SIDEPANEL, {
      dashboard_id: dashboard.id,
      project_id: dashboard.project.id,
    });
  };

  return (
    <BaseAnalyticsSidepanelItem
      {...props}
      item={props.analyticsDashboard}
      handleClickStar={handleClickStar}
      starred={props.analyticsDashboard.starred}
      trackOpenEvent={trackOpenEvent}
    />
  );
}
